import React from 'react';
import useImageCache from '../hooks/useImageCache';
import './ImageWithDownload.css';

function ImageWithDownload({ src, alt, className, style, filename, imgStyle, disableCache = false }) {
    const { containerRef, cachedSrc, loading, error } = useImageCache(src, !disableCache);
    const showPlaceholder = loading && !error;
    // The wrapper only stretches when the caller did not size it itself.
    const isFullWidth = !(style?.width || style?.maxWidth);

    const handleDownload = async (e) => {
        e.stopPropagation(); // Prevent triggering parent click handlers

        try {
            // Fetch the image
            const response = await fetch(src);
            const blob = await response.blob();

            // Create a temporary URL for the blob
            const url = window.URL.createObjectURL(blob);

            // Create a temporary anchor element and trigger download
            const link = document.createElement('a');
            link.href = url;
            link.download = filename || `image_${Date.now()}.png`;
            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (downloadError) {
            // Fallback: open in new tab
            window.open(src, '_blank');
        }
    };

    return (
        <div
            ref={containerRef}
            className={`image-with-download${isFullWidth ? ' image-with-download--full-width' : ''}`}
            style={style}
        >
            {showPlaceholder && (
                <div className="image-with-download__placeholder">
                    <span className="image-with-download__placeholder-label">
                        {alt || 'Loading image'}
                    </span>
                </div>
            )}
            {(cachedSrc || error) && (
                <img
                    src={cachedSrc || src}
                    alt={alt}
                    className={`${className || ''}${showPlaceholder ? ' image-with-download__img--hidden' : ''}`.trim() || undefined}
                    loading="lazy"
                    decoding="async"
                    style={imgStyle}
                />
            )}
            <button
                type="button"
                className="image-with-download__button"
                onClick={handleDownload}
                title="Download image"
                aria-label="Download image"
            >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
            </button>
        </div>
    );
}

export default ImageWithDownload;
